var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5291 3.30242C12.9162 3.14209 13.331 3.05957 13.75 3.05957C14.169 3.05957 14.5838 3.14209 14.9709 3.30242C15.358 3.46275 15.7097 3.69775 16.0059 3.994C16.3022 4.29026 16.5372 4.64196 16.6975 5.02903C16.8578 5.4161 16.9404 5.83097 16.9404 6.24993C16.9404 6.66889 16.8578 7.08375 16.6975 7.47082C16.5372 7.85789 16.3022 8.2096 16.0059 8.50585L7.25592 17.2558C7.09964 17.4121 6.88768 17.4999 6.66667 17.4999H3.33333C2.8731 17.4999 2.5 17.1268 2.5 16.6666V13.3333C2.5 13.1122 2.5878 12.9003 2.74408 12.744L11.4941 3.994C11.7903 3.69775 12.142 3.46275 12.5291 3.30242ZM13.75 4.72624C13.5499 4.72624 13.3518 4.76565 13.1669 4.84222C12.982 4.91879 12.8141 5.03103 12.6726 5.17252L4.16667 13.6784V15.8333H6.32149L14.8274 7.32734C14.9689 7.18585 15.0811 7.01788 15.1577 6.83302C15.2343 6.64816 15.2737 6.45002 15.2737 6.24993C15.2737 6.04983 15.2343 5.8517 15.1577 5.66684C15.0811 5.48197 14.9689 5.314 14.8274 5.17252C14.6859 5.03103 14.518 4.91879 14.3331 4.84222C14.1482 4.76565 13.9501 4.72624 13.75 4.72624Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6611 4.82806C10.9865 4.50263 11.5141 4.50263 11.8396 4.82806L15.1729 8.1614C15.4984 8.48683 15.4984 9.01447 15.1729 9.33991C14.8475 9.66534 14.3198 9.66534 13.9944 9.33991L10.6611 6.00657C10.3356 5.68114 10.3356 5.1535 10.6611 4.82806Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.2efd2cec0b070bb273bd74446442a89f.svg";
export { ForwardRef as ReactComponent };